module.exports = __webpack_public_path__ + "img/soldering_mixing.196e8c0f.jpg";